import { Bus } from "@website/icons/components/bus";
import { Flight } from "@website/icons/components/flight";
import { FlightInternational } from "@website/icons/components/flight-international";
import { FlightLuggage } from "@website/icons/components/flight-luggage";
import { Hotel } from "@website/icons/components/hotel";
import { HotelInternational } from "@website/icons/components/hotel-international";
import { Train } from "@website/icons/components/train";
import { Villa } from "@website/icons/components/villa";
import { busLinksArray } from "../components/links/linksSchmea/bus";
import { domFlightLinksArray } from "../components/links/linksSchmea/dom-flight";
import { domHotelLinksArray } from "../components/links/linksSchmea/dom-hotel";
import { intlFlightLinksArray } from "../components/links/linksSchmea/intl-flight";
import { intlHotelLinksArray } from "../components/links/linksSchmea/intl-hotel";
import { tourLinksArray } from "../components/links/linksSchmea/tour";
import { trainLinksArray } from "../components/links/linksSchmea/train";
import { villaLinksArray } from "../components/links/linksSchmea/villa";
import { Template } from "../components/links/template";

export const allServices = [
  {
    url: `/`,
    title: "هتل داخلی",
    icon: <Hotel />,
    links: <Template linksArray={domHotelLinksArray} />
  },
  {
    url: `/international-hotel`,
    title: "هتل خارجی",
    icon: <HotelInternational />,
    links: <Template linksArray={intlHotelLinksArray} />
  },
  {
    url: `/flights`,
    title: "پرواز داخلی",
    icon: <Flight />,
    links: <Template linksArray={domFlightLinksArray} />
  },
  {
    url: `/inter-flights`,
    title: "پرواز خارجی",
    icon: <FlightInternational />,
    links: <Template linksArray={intlFlightLinksArray} />
  },
  {
    url: `/bus`,
    title: " بلیط اتوبوس",
    icon: <Bus />,
    links: <Template linksArray={busLinksArray} />
  },
  {
    url: `/train`,
    title: " بلیط قطار",
    icon: <Train />,
    links: <Template linksArray={trainLinksArray} />
  },
  {
    url: `/villa`,
    title: "ویلا و اقامتگاه",
    icon: <Villa />,
    links: <Template linksArray={villaLinksArray} />
  },
  {
    url: `/tour`,
    title: "تورهای مسافرتی",
    icon: <FlightLuggage />,
    links: <Template linksArray={tourLinksArray} />
  }
];
